import { render } from "./SnapshotTargetVolume.vue?vue&type=template&id=298b2b6a"
import script from "./SnapshotTargetVolume.vue?vue&type=script&lang=js"
export * from "./SnapshotTargetVolume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__